<template>
	<a v-if="!showActiveOnly || (showActiveOnly && active)" 
	href="#" aria-role="button" tabindex="0" v-on:click.stop.prevent="addToDownloads" 
	:class="['button', 'downloads', 'toggle-file', 'has-icon', 'icon-right', classes, {
		'active':active, 
		'has-image': useFilename && typeof item.image !== 'undefined',
		'no-image': !useFilename
	}]" 
	:title="label">
		<span class="label" v-text="labelShort"></span>
		<!--<span class="plus-or-close"></span>-->
		<img v-if="useFilename && typeof item.image !== 'undefined' && typeof item.image !== 'undefined'" v-bind:src="item.image.thumbnail" />
	</a>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
	props: ['type', 'itemId', 'item', 'classes', 'showActiveOnly', 'useFilename'],
	data() {
		return {
			active: false,
		}
	},
	computed: {
		...mapState('downloads', {
			selectedArticles: state => state.article,
			selectedNotes: state => state.note,
			selectedGraphs: state => state.graph,
		}),
		label() {
			if (this.useFilename && typeof this.item.image !== 'undefined' && this.item.image) return this.item.image.filename;
			if (this.useFilename && typeof this.item.pdf !== 'undefined' && this.item.pdf) return this.item.pdf.filename;
			if (this.item) return this.item.title;
			var string = (this.active) ? this.$t('remove_from_download_center') : this.$t('add_to_download_center')
			return string
		},
		labelShort() {
			if (this.useFilename && typeof this.item.image !== 'undefined' && this.item.image) return this.item.image.filename_short;
			if (this.useFilename && typeof this.item.pdf !== 'undefined' && this.item.pdf) return this.item.pdf.filename_short;
			return this.label
		}
	},
	methods: {
		...mapActions('downloads', {
			add: 'addItem',
			remove: 'removeItem',
			isAdded: 'isItemAdded'
		}),
		addToDownloads() {
			this.active = !this.active
			var data = { type: this.type, itemId: this.itemId }
			if (this.active) {
				this.add(data)
				this.$emit('downloadItemAdded', data)
			} else {
				this.remove(data)
				this.$emit('downloadItemRemoved', data)
			}
		},
		setupItem() {
			this.isAdded({ type: this.type, itemId: this.itemId }).then(response => {
				this.active = response
			})
		}
	},
	created() {
		this.setupItem()
	},
	watch: {
		'$route': 'setupItem',
		'selectedArticles': 'setupItem',
		'selectedNotes': 'setupItem',
		'selectedGraphs': 'setupItem',
	}
}
</script>